module.exports = __webpack_public_path__ + "img/zaymer.32b9f3d4.svg";